export default ({ request }) => ({

// 供应商评价信息相关接口

  scmInfoAppraisalListApi(data) {
    return request({
      url: '/digitalCenter/scmInfoAppraisal/list',
      method: 'post',
      data
    })
  },
  scmInfoAppraisalDetailApi(data) {
    return request({
      url: '/digitalCenter/scmInfoAppraisal/detail',
      method: 'post',
      data
    })
  },
  scmInfoAppraisalSaveApi(data) {
    return request({
      url: '/digitalCenter/scmInfoAppraisal/save',
      method: 'post',
      data
    })
  }
})
